import React from "react";
import "./index.css";

const complexes = [
  {
    name: "Апарт-отель Ladozhsky AVENIR",
    url: "https://partapart.ru/kompleksy/apart-otel-ladozhsky-avenir",
    address: "Санкт-Петербург, ул. Магнитогорская, д. 51 лит. З",
    metro: "Ладожская",
    deadline: "4 квартал 2024",
  },
  {
    name: "Апарт-отель Well",
    url: "https://partapart.ru/kompleksy/apart-otel-well",
    address: "Санкт-Петербург, наб Обводного канала, д. 118а, литера П",
    metro: "Балтийская",
    deadline: "4 квартал 2023",
  },
  {
    name: "Инвест-отель VIDI",
    url: "https://partapart.ru/kompleksy/invest-otel-vidi",
    address: "Санкт-Петербург, Синопская наб., 30",
    metro: "Площадь Александра Невского 1",
    deadline: "2 квартал 2025",
  },
  {
    name: "Апарт-отель YE’S Leader",
    url: "https://partapart.ru/kompleksy/apart-otel-ye%E2%80%99s-leader",
    address: "Санкт-Петербург, Ленинский проспект, д. 153",
    metro: "Московская",
    deadline: "2 квартал 2026",
  },
  {
    name: "Апарт-отель 25/7 Заневский",
    url: "https://partapart.ru/kompleksy/apart-otel-25/7-zanevskij",
    address: "Санкт-Петербург, Заневский проспект 65, лит. А",
    metro: "Ладожская",
    deadline: "2 квартал 2024",
  },
  {
    name: "Апарт-отель ARTSTUDIO M103",
    url: "https://partapart.ru/kompleksy/apart-otel-artstudio-m103",
    address: "Санкт-Петербург, Московский пр., д. 103",
    metro: "Московские ворота",
    deadline: "2 квартал 2024",
  },
  {
    name: "Апарт-отель SHINE",
    url: "https://partapart.ru/kompleksy/apart-otel-shine",
    address: "ул. Таллинская, д.11, с.2",
    metro: "Новочеркасская",
    deadline: "дом сдан",
  },
  {
    name: "Апарт-отель Kirovsky AVENIR",
    url: "https://partapart.ru/kompleksy/apart-otel-kirovsky-avenir",
    address: "ул. Кронштадтская, д. 9, к.2",
    metro: "Автово",
    deadline: "дом сдан",
  },
  {
    name: "Апарт-отель Moskovsky AVENIR",
    url: "https://partapart.ru/kompleksy/apart-otel-moskovsky-avenir",
    address: "ул. Киевская, д. 5",
    metro: "Фрунзенская",
    deadline: "дом сдан",
  },
  {
    name: "Апарт-отель YouCo living",
    url: "https://partapart.ru/kompleksy/apart-otel-youandco-living",
    address: "г. Санкт-Петербург, ул. Орджоникидзе, д.44",
    metro: "Московская",
    deadline: "4 квартал 2023",
  },
  {
    name: "Апарт-отель Putilov AVENIR",
    url: "https://partapart.ru/kompleksy/putilov-avenir",
    address: "Санкт-Петербург, Стачек пр-т, д.64, лит. А",
    metro: "Кировский завод",
    deadline: "дом сдан",
  },
  {
    name: "Апарт-отель Vertical Московская",
    url: "https://partapart.ru/kompleksy/apart-kompleks-ramada-encore-by-wyndham",
    address: "Санкт-Петербург, ул. Орджоникидзе, д.44",
    metro: "Московская",
    deadline: "3 квартал 2025",
  },
  {
    name: "AVENUE-APART на Дыбенко",
    url: "https://partapart.ru/kompleksy/avenue-apart-na-dybenko",
    address: "Санкт-Петербург, Товарищеский пр-т. д.19",
    metro: "Улица Дыбенко",
    deadline: "3 квартал 2023",
  },
  {
    name: "Инвест-отель ПРО`МОЛОDOСТЬ",
    url: "https://partapart.ru/kompleksy/apart-otel-promolodost",
    address: "Санкт-Петербург, Проспект Большевиков, д.32, к.4",
    metro: "Улица Дыбенко",
    deadline: "3 квартал 2023",
  },
  {
    name: "Апарт-отель START",
    url: "https://partapart.ru/kompleksy/apart-otel-start",
    address:
      "Санкт-Петербург город, п.Парголово, пр-кт Энгельса, д. 174, литера А",
    metro: "Парнас",
    deadline: "дом сдан",
  },
  {
    name: "AVENUE-APART на Малом",
    url: "https://partapart.ru/kompleksy/avenue-apart-na-malom",
    address:
      "Санкт-Петербург, Малый проспект В.О., д.54, к.2, лит. А1",
    metro: "Василеостровская",
    deadline: "дом сдан",
  },
  {
    name: "Лофт-квартал Docklands",
    url: "https://partapart.ru/kompleksy/apart-otel-docklands",
    address: "Санкт-Петербург, Набережная Макарова, д.60",
    metro: "Приморская",
    deadline: "дом сдан",
  },
  {
    name: "Апарт-отель Next",
    url: "https://partapart.ru/kompleksy/apart-otel-next",
    address: "Санкт-Петербург, Средний В.О. пр-т, д.87, лит.М",
    metro: "Василеостровская",
    deadline: "дом сдан",
  },
  {
    name: "Инвест-отель In2It",
    url: "https://partapart.ru/kompleksy/apart-otel-in2it",
    address: "Санкт-Петербург, Витебский пр. д.101",
    metro: "Купчино",
    deadline: "4 квартал 2022",
  },
  {
    name: "Апартаменты WINGS",
    url: "https://partapart.ru/kompleksy/apart-otel-wings",
    address: "Санкт-Петербург, ул. Крыленко, д.14",
    metro: "Улица Дыбенко",
    deadline: "4 квартал 2022",
  },
  {
    name: "Апарт-отель VALO",
    url: "https://partapart.ru/kompleksy/apart-otel-valo",
    address: "Санкт-Петербург, ул. Салова, д.61, лит.А",
    metro: "Бухарестская",
    deadline: "1 квартал 2023",
  },
  {
    name: "Апарт-отель Vertical Лесная",
    url: "https://partapart.ru/kompleksy/apart-otel-vertical-weandi",
    address: "Санкт-Петербург, Большой Сампсониевский пр-т, д.74 к.2",
    metro: "Лесная",
    deadline: "дом сдан",
  },
];

export default function App() {
  return (
    <div className="pa-page">
      <header className="pa-header">
        <div className="pa-header-inner">
          <a href="https://partapart.ru/" className="pa-logo">
            PartApart
          </a>
          <nav className="pa-nav">
            <a href="https://partapart.ru/apartaments">Купить апартаменты</a>
            <a href="https://partapart.ru/programs">Доходные программы</a>
            <a href="https://partapart.ru/novosti-i-analitika">
              Новости и аналитика
            </a>
          </nav>
          <div className="pa-header-right">
            <span className="pa-fav-count">0</span>
            <a href="https://partapart.ru/account" className="pa-account-link">
              Личный кабинет
            </a>
          </div>
        </div>
      </header>

      <main className="pa-main">
        <section className="pa-hero">
          <h1>Апарт-отели Санкт-Петербурга</h1>
          <p>
            Экспертное сравнение программ доходности апарт-отелей, класса
            апартаментов, условий покупки, срок сдачи, фото, наличие
            управляющей компании, удаленность от метро, меблировка. Цены от
            застройщика. Прогнозы доходности инвестиций и перспективы развития
            рынка апартаментов. Юридические особенности владения апартаментами.
          </p>
          <button className="pa-map-button">Апарт-отели на карте</button>

          <div className="pa-map-wrapper">
            <div className="pa-map">
              <div className="pa-map-background" />
              <div className="pa-map-points">
                {complexes.map((c, index) => {
                  const col = index % 6;
                  const row = Math.floor(index / 6);
                  const left = 8 + col * 15;
                  const top = 20 + row * 12;
                  return (
                    <div
                      key={c.name}
                      className="pa-map-point"
                      style={{ left: `${left}%`, top: `${top}%` }}
                      title={c.name}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </section>

        <section className="pa-complexes">
          <div className="pa-cards-grid">
            {complexes.map((c) => (
              <article key={c.name} className="pa-card">
                <div className="pa-card-image" />
                <a
                  className="pa-card-badge"
                  href={c.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  акция % анонс
                </a>
                <h2 className="pa-card-title">
                  <a href={c.url} target="_blank" rel="noopener noreferrer">
                    {c.name}
                  </a>
                </h2>
                <ul className="pa-card-list">
                  <li>{c.address}</li>
                  <li>
                    <strong>Метро:</strong> {c.metro}
                  </li>
                  <li>
                    <strong>Срок сдачи:</strong> {c.deadline}
                  </li>
                </ul>
              </article>
            ))}
          </div>
        </section>
      </main>

      <footer className="pa-footer">
        <div className="pa-footer-top">
          <div className="pa-footer-brand">
            <a href="https://partapart.ru/">Partapart</a>
            <a href="https://partapart.ru/goryachaya-liniya">
              Горячая линия
            </a>
            <a href="https://partapart.ru/pressa-o-nas">Пресса о нас</a>
            <button className="pa-footer-linkLike">Подписаться на новости</button>
            <button className="pa-footer-linkLike">Нашли ошибку?</button>
            <a href="https://partapart.ru/documents/pravila-polzovaniya-sajtom">
              Документы
            </a>
          </div>

          <div className="pa-footer-cols">
            <div>
              <a href="https://partapart.ru/kompleksy">Апарт-отели</a>
              <a href="https://partapart.ru/apartaments">Купить апартаменты</a>
              <a href="https://partapart.ru/programs">Доходные программы</a>
            </div>
            <div>
              <a href="https://partapart.ru/faq/chto-takoe-apartamenty">
                Вопрос/ответ
              </a>
              <a href="https://partapart.ru/novosti-i-analitika">
                Новости и аналитика
              </a>
              <a href="https://partapart.ru/sravnenie-obektov">
                Сравнение апартаментов
              </a>
            </div>
            <div className="pa-footer-contact">
              <a href="tel:+79119070256">+7 (911) 907-02-56</a>
              <a href="mailto:info@partapart.ru">info@partapart.ru</a>
            </div>
          </div>
        </div>

        <div className="pa-footer-bottom">
          <a href="https://ra-logika.ru/">Создание сайтов - Logika</a>
          <span>
            © PARTAPART, 2019. Все материалы данного сайта являются объектами
            авторского права (в том числе дизайн). Запрещается копирование,
            распространение или иное использование информации без согласия
            правообладателя.
          </span>
          <a href="https://partapart.ru/otvetstvennost-za-narushenie-avtorskih-prav">
            Статья 1252 ГК РФ. Защита исключительных прав.
          </a>
        </div>
      </footer>
    </div>
  );
}
